import { Component, OnInit, Input, ElementRef } from '@angular/core';
import { BaseService } from '../../../base/shared/services/base.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FilterService } from 'src/modules/base/services/filter.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { PrintService } from 'src/modules/base/shared/services/print.service';
import { UtilService } from 'src/modules/base/services/util.service';

@Component({
    selector: 'kx-sample-track',
    templateUrl: './sample-track.component.html',
    styleUrls: ['./sample-track.component.scss'],
    standalone: false
})
export class SampleTrackComponent implements OnInit {
  @Input() statusData: any;
  @Input() config: any;
  @Input() input: string;
  resource: string;
  data: any;
  result: any = [];
  keys: any = [];
  type: boolean;
  itemsCount: any;
  searchKey: any;
  private page = 1;
  limit = 10;
  applcationName: string;
  filterKey: any
  showobjarray: boolean;
  resouceDef: any;
  GridData: any;
  stationInfo: any;
  searchConfig: any = {};

  constructor(
    private baseService: BaseService,
    private elementRef: ElementRef,
    private router: ActivatedRoute,
    private route: Router,
    private filterService: FilterService,
    private loader: LoaderService,
    public utilService: UtilService,
    private printService?: PrintService
  ) { }

  ngOnInit() {
    if (this.input) {
      this.getCurrentResource(this.input);
    }
    this.baseService.setTitle("Track Order");
  }
  //get current resource
  getCurrentResource(resource) {
    this.baseService.getResourceDef(resource, (resouceDef) => {
      if (resouceDef) {
        this.resouceDef = resouceDef;
        if (resouceDef.metro != undefined) {
          let info = this.resouceDef.metro.find(x => x.name == 'station_name');
          this.get_stations_stationstatus(info);
        }
        this.searchConfig.complex_search = resouceDef.complex_search;
        this.searchConfig.barcode_config = resouceDef.barcode_config;
      }
    });
  }


  threeDotsclick(event) {
    let childElem = this.elementRef.nativeElement.getElementsByClassName('data-grid-footer');
    let childElem2 = this.elementRef.nativeElement.getElementsByClassName('grid-container');
    childElem[0].classList.toggle("sm-index");
    childElem2[0].classList.toggle("lg-index");
  }
  redirect(action: any, btnAction) {
    if (btnAction.action == 'print')
      this.handleFile(btnAction, action)
    else {
      this.route.navigate(["/" + btnAction.application + "/" + btnAction.type], { queryParams: { returnUrl: this.route.url } })
      let data_ = this.GridData.find(x => x[btnAction.key] == action[btnAction.key]);
      if (data_ != undefined && data_) {
        sessionStorage.setItem("currentData", JSON.stringify(data_));
      }
    }
  }

  handleFile(action, obj, callback = null) {
    this.printService.handlePrint(action, obj, callback)
  }
  checkCondition() {
    this.router.queryParams.subscribe((result: Object) => {
      if (result.hasOwnProperty("tab_0")) {
        return false
      } else {
        return true
      }
    })
  }

  checkKeys(key: any) {
    if (key == 'patient_name' || key == 'tableId') {
      return false
    } else {
      return true
    }
  }
  //setting status station and station status
  async get_stations_stationstatus(info) {
    info.datasource.args = info.datasource.args != undefined ? this.baseService.buildDyanamicStr(info.datasource.args, { data: this.data }) : '';
    info.datasource.filter = info.datasource.filter != undefined ? this.baseService.buildDyanamicStr(info.datasource.filter, { data: this.data }) : '';
    if (info.name == 'station_name') {
      this.getStationName(info);
      console.log("IN keys check7", this.keys);
    }
    else if (info.name == 'station_status') {
      this.stationInfo = info;
      let data = {
        filter: this.stationInfo.datasource.filter,
        args: this.stationInfo.datasource.args,
        page_no: 0,
        page_size: 10
      }
      if (this.stationInfo.datasource.search != undefined && this.stationInfo.datasource.search) {
        data['search'] = this.stationInfo.datasource.search;
        data['search_columns'] = this.stationInfo.datasource.search_columns ? this.stationInfo.datasource.search_columns : '';
      }
      setTimeout(x => { this.getDataOfRows(this.stationInfo, data); });
    }
    console.log("keys are as follows::", this.keys);

  }
  //getting all stations info
  async getStationName(info) {
    await this.baseService.get(info.datasource.query_id, info.datasource.args, info.datasource.resource, info.datasource.application, info.datasource.filter).toPromise().then(data => {
      console.log("get data is as is as::", data);
      if (info.name == 'station_name') {
        this.showobjarray = true;
        for (let i = 0; i < data.resource.length; i++) {
          this.keys.push({ "key": data.resource[i][info.key], "display": data.resource[i][info.display], "visible": true });
        }
        this.setDefaultColumns();
        console.log("keys after column::", this.keys);
      }
    })
  }
  //making columns
  setDefaultColumns() {
    console.log("IN keys correct check2", this.keys);
    if (this.resouceDef.default_columns != undefined && this.resouceDef.default_columns.length) {
      for (let i = 0; i < this.resouceDef.default_columns.length; i++) {
        this.keys.unshift({ "key": this.resouceDef.default_columns[i]['name'], "display": this.resouceDef.default_columns[i]['heading'], "default": true, "visible": this.resouceDef.default_columns[i]['visible'] == undefined ? true : this.resouceDef.default_columns[i]['visible'] });
      }
      let info = this.resouceDef.metro.find(x => x.name == 'station_status');
      this.get_stations_stationstatus(info);
    }
    console.log("IN keys correct check3", this.keys);
  }
  getDataOfRows(info, data?) {
    this.loader.showSpinner();
    this.baseService.getWithPage(data, info.datasource.resource, info.datasource.application, info.datasource.query_id).subscribe(data => {
      this.loader.hideSpinner();
      if (data && data.resource != undefined && data.resource) {
        this.itemsCount = data.count;
        this.GridData = data.resource;
        this.setPatientData_(data.resource);
      }
    })
  }
  setPatientData_(temp) {
    console.log("IN keys", this.keys);
    let tempVar: any;
    this.result = [];
    if (temp.length > 0) {
      for (let j = 0; j < temp.length; j++) {
        let patientData = {};
        for (let i = 0; i < this.keys.length; i++) {
          for (let key in temp[j]) {
            if (this.keys[i].key === key) {
              patientData[key] = temp[j][key];
              tempVar = (JSON.parse(JSON.stringify(patientData)));
              console.log("value added at ::", patientData);
            }

          }
        }
        if (tempVar != undefined) {
          this.result.push(tempVar);
        }
      }
    }
    console.log("Result & Keys", this.result, this.keys);
  }
  displayFilter() {
    //this.show_filter = !this.show_filter;
    if (this.resouceDef.filter_form.hasOwnProperty('default_open')) {
      this.resouceDef.filter_form.default_open = !this.resouceDef.filter_form.default_open
      this.searchConfig['filterOpenStatus'] = this.resouceDef.filter_form.default_open;
    }
  }
  //for filter Search
  doSearch(data) {
    let info = {};
    // let info = data.filter;
    info = this.resouceDef.metro.find(x => x.name == 'station_status');
    if (info) {
      info['datasource']['filter'] = data;
      info['datasource']['filter'] = this.filterService.removeDuplicateKeysFromString({ "filter": info['datasource'].filter });
    }
    this.get_stations_stationstatus(info);
  }
  // searchFilter(searchText) {
  //   let info = {};
  //   info = this.resouceDef.metro.find(x => x.name == 'station_status');
  //   if (info) {
  //     info['datasource']['search'] = searchText;
  //   }
  //   this.get_stations_stationstatus(info);
  // }
  filterClick(event) {
    let info = {};
    info = this.resouceDef.metro.find(x => x.name == 'station_status');
    if (info) {
      if (typeof event == 'object') {
        info['datasource']['search'] = event.value;
        info['datasource']['search_columns'] = event.key;
      }
      else {
        info['datasource']['search'] = event.value;
      }
    }
    this.get_stations_stationstatus(info);
  }
  concatObjectValues(key, object) {
    //console.log("Inside ",key, object);
    var x: any;
    for(let a in object) {
      if (object[a] == '' || object[a] == undefined) { }
      else if (x == undefined || x == '') {
        x = key + '.' + a + ':' + object[a];
      } else {
        x = x + ',' + (key + '.' + a + ':' + object[a]);
      }
    }
    // console.log("X is ",x);
    return (x);
  }
  public onLimit(event) {
    this.limit = event.target.value;
    this.page = 0;
    let data = {
      filter: this.stationInfo.datasource.filter,
      args: this.stationInfo.datasource.args,
      page_no: this.page,
      page_size: event.target.value
    }
    this.getDataOfRows(this.stationInfo, data);
  }
  onPageChanged(event: any) {
    this.page = event.page - 1;
    let data = {
      filter: this.stationInfo.datasource.filter,
      args: this.stationInfo.datasource.args,
      page_no: this.page,
      page_size: this.limit || 0
    }
    this.getDataOfRows(this.stationInfo, data);
  }
}

